<div class="input-group row" [ngClass]="{ 'input-group-sm': smallInput }">
    @if (prependLabel) {
        <div class="input-group-prepend col-md-3">
            <span class="input-group-text">{{ prependLabel }}</span>
        </div>
    }
    <select
        class="form-select custom-select col-md-{{ prependLabel ? '8' : '11' }}"
        id="{{ comboboxId }}"
        [(ngModel)]="selectedValue"
    >
        @for (option of options; track option) {
            <option [value]="option.ID" [selected]="selectedValue == option.ID">
                {{ option.Name }}
            </option>
        }
    </select>
    <div class="input-group-append col-md-1">
        <button
            class="{{ customClass }} btn btn-outline-secondary clear-button"
            id="clear-button"
            type="button"
            (click)="clear()"
        >
            <i class="fas fa-times"></i>
        </button>
    </div>
</div>
